const exam = {
    namespaced : true,
    state : {
        preQuestions: []
    },
    mutations : {
        setPreQuestions(state, payload) {
            state.preQuestions = payload
        }
    },
    getters : {
        getPreQuestions(state) {
            return state.preQuestions
        }
    }
};

export default exam;


// WEBPACK FOOTER //
// ./src/stores/modules/exam.js